import { Anchor, AnchorVariant, IButtonProps } from 'components/admin/ui';
import { useWhiteLabelContext } from 'components/white-label';
import { CompanySize } from 'lib/types/company';
import { MouseEventHandler } from 'react';
import {
  getCanScheduleSalesCall,
  getCompanySizeFromLearnerCount,
} from './helpers';
import { useSalesRequestContext } from './SalesRequestContext';

const BUTTON_VARIANT_TO_ANCHOR_VARIANT: { [key: string]: AnchorVariant } = {
  solid: 'button-solid',
  outline: 'button-outline',
  link: 'anchor',
};

export interface ISalesRequestButtonProps extends IButtonProps {
  interest?: string;
  licenseCount?: number;
  alwaysSendToSales?: boolean;
  onClick?: () => void;
  fullstoryId?: string;
}

export const SalesRequestButton = ({
  children,
  className,
  icon,
  interest,
  variant = 'solid',
  licenseCount,
  alwaysSendToSales = false,
  onClick = () => null,
  size,
  fullstoryId,
}: ISalesRequestButtonProps) => {
  const {
    companySize: defaultCompanySize,
    setInterest,
    setCompanySize,
    toggleSalesRequestModal,
  } = useSalesRequestContext();
  const { supportEmail } = useWhiteLabelContext();

  const companySize = licenseCount
    ? getCompanySizeFromLearnerCount(licenseCount)
    : defaultCompanySize;

  const canScheduleSalesCall = getCanScheduleSalesCall(companySize);

  const handleClick: MouseEventHandler = (e) => {
    e.stopPropagation();
    setCompanySize(
      !canScheduleSalesCall && alwaysSendToSales
        ? CompanySize.FIFTY_ONE_TO_TWO_FIFTY
        : companySize
    );
    setInterest(interest);
    toggleSalesRequestModal();
    onClick();
  };

  // Chilipiper changed how embedding forms works. Always send to email for now.
  // https://ethena-team.monday.com/boards/3831714395/pulses/8880171827
  //
  // if (canScheduleSalesCall || alwaysSendToSales) {
  //   return (
  //     <Button
  //       className={className}
  //       icon={icon}
  //       onClick={handleClick}
  //       size={size}
  //       variant={variant}
  //       data-fullstoryid={fullstoryId}
  //     >
  //       {children}
  //     </Button>
  //   );
  // }

  return (
    <Anchor
      className={className}
      href={`mailto:${supportEmail}`}
      icon={icon}
      onClick={(e) => e.stopPropagation()}
      size={size}
      target="_blank"
      variant={BUTTON_VARIANT_TO_ANCHOR_VARIANT[variant]}
    >
      {children}
    </Anchor>
  );
};
